import { memo as c, Fragment as m } from "react";
import { jsxs as l, jsx as s } from "react/jsx-runtime";
const g = c(({
  box: n
}) => {
  const a = Array(4).fill(!0), e = 0.2, r = 0.5, i = [n.x, n.y + n.height + 2];
  return /* @__PURE__ */ l("g", {
    "data-name": "scale",
    transform: `translate(${i.join(",")})`,
    children: [a.map((o, t) => /* @__PURE__ */ l(m, {
      children: [/* @__PURE__ */ s("text", {
        fontSize: r,
        alignmentBaseline: "after-edge",
        x: t,
        y: e,
        children: t
      }), /* @__PURE__ */ s("rect", {
        x: t,
        y: t % 2 ? e : e * 2,
        fill: "#000",
        width: 1,
        height: e
      })]
    }, t)), /* @__PURE__ */ l("text", {
      fontSize: r,
      alignmentBaseline: "after-edge",
      x: a.length,
      y: e,
      children: [a.length, "M"]
    })]
  });
});
g.displayName = "SvgScale";
export {
  g as SvgScale
};
//# sourceMappingURL=index7.js.map
